import { useState } from 'react';
import largeCloseIcon from '../../../images/larger-close-icon.svg';
import * as Styled from './FaqSubItemStyles';
import Headline from '../Headline/Headline';

export interface FaqSubItemStandardProps {
  header: string;
  text: string;
}

const FaqSubItem = ({ header, text }: FaqSubItemStandardProps) => {
  const [isParagraphVisible, setParagraphVisible] = useState(false);

  return (
    <Styled.Container className="FaqSubitem">
      <Headline tag="h3" className="ItemSubTitle"
        onClick={() => setParagraphVisible(currValue => !currValue)}
      >
        {header}
        {
          isParagraphVisible ?
            <Styled.StyledImg src={largeCloseIcon} />
            :
            null
        }
      </Headline>
      {
        isParagraphVisible ?
          <Styled.Container className="FaqSubitemTextWrapper">
            <Styled.StyledParagraph>
              {
                (typeof text === 'string' && text.includes('info@gotrova.ai')) ?
                  <span>
                    Contact us via
                    <a href='mailto:info@gotrova.ai'> info@gotrova.ai </a>
                    for any difficulties you encountered using Trova. Our support team will get back to you as soon as possible.
                  </span>
                  :
                  text
              }
            </Styled.StyledParagraph>
          </Styled.Container>
          :
          null
      }
    </Styled.Container>
  );
}

export default FaqSubItem;